import {Separator} from 'platform/components';
import {Show, VStack} from 'platform/foundation';

import {
  VehicleForm as VFKit,
  VehicleSubSections as VFSubSection,
  VehicleFormDefaultLayout,
  useIsCardExpandable,
  isElectricOrHybridFuelType,
} from '@dms/features/vehicle-forms-kit';
import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';

import {AdditionalInfoWidget} from '../components/AdditionalInfoWidget';

interface SaleVehicleDataProps {
  shouldShowWarranties: boolean;
}

export function SaleVehicleData(props: SaleVehicleDataProps) {
  const isExpandable = useIsCardExpandable();

  const [canReadBusinessCase] = usePermissions({
    permissionKeys: ['businessCaseRead'],
  });

  return (
    <VehicleFormDefaultLayout>
      <VehicleFormDefaultLayout.Left>
        <VStack spacing={4}>
          <VFKit.Section
            data-testid="vehicle-data"
            isExpandable={isExpandable}
            title={isExpandable ? i18n.t('entity.vehicle.labels.vehicleData') : undefined}
          >
            <VFSubSection.VehicleCondition />
            <VFSubSection.MileageOwnership />
            <VFSubSection.VehicleRegistrationCountries />
            <VFKit.ShowWhen when={canReadBusinessCase}>
              <VFSubSection.VehicleSource showSaleFields />
            </VFKit.ShowWhen>
            <Separator spacing={1} />
            <VFSubSection.RegistrationDocuments />
            <VFKit.ShowWhen
              name="fuelType"
              condition={(fuelType) => isElectricOrHybridFuelType(fuelType?.[0])}
            >
              <VFSubSection.BatteryHealth />
            </VFKit.ShowWhen>
            <VFSubSection.Warranty />
            <Show when={props.shouldShowWarranties}>
              <VFSubSection.Warranties />
            </Show>
            <VFSubSection.TechnicalInspection />
            <VFSubSection.ServiceBook />
            <VFSubSection.ServiceInspection />
          </VFKit.Section>
        </VStack>
      </VehicleFormDefaultLayout.Left>
      <VehicleFormDefaultLayout.Right>
        <VFKit.SubSection data-testid="additional-info">
          <AdditionalInfoWidget />
        </VFKit.SubSection>
      </VehicleFormDefaultLayout.Right>
    </VehicleFormDefaultLayout>
  );
}
